import cn from 'classnames';
import type { UserData } from '../api/product';
import Icon from '../generic/Icon';
import showConfirmDialog from '../generic/showConfirmDialog';
import type { ProductCardDetails } from '../product/ProductCard';
import preventDefault from '../utils/preventDefault';
import ProductListTool from './ProductListTool';
import ProductRatingTool from './ProductRatingTool';
import ProductShareTool from './ProductShareTool';
import * as style from './ProductTools.module.css';

interface Props {
    product: ProductCardDetails;
    productUserData?: { review?: { rating: number; comment?: string }; inList: boolean };
    onUserDataChange(userData: UserData): void;
    showRatingTool?: boolean;
    padding?: boolean;
}

export default function ProductTools({ product, productUserData, onUserDataChange, padding, showRatingTool = true }: Props) {
    const { comment = '', rating } = productUserData?.review || { rating: undefined };
    return (
        <div className={cn(style.productTools, { [style.padding]: padding })}>
            {showRatingTool && <ProductRatingTool productCode={product.code} rating={rating} comment={comment} onUserDataChange={onUserDataChange} />}
            <ProductListTool product={product} inList={productUserData?.inList} onUserDataChange={onUserDataChange} />
            <ProductShareTool url={product.url} title={product.name} />
        </div>
    );
}

export function NotificationProductTools({ product, onDelete }: { product: ProductCardDetails; onDelete: (product: ProductCardDetails) => void }) {
    return (
        <div className={style.productTools}>
            <button
                className="btn-icon"
                onClick={preventDefault(() => showConfirmDialog(`Ønsker du å slette varsling for ${product.name}?`, () => onDelete(product)))}
                aria-label="Fjern varsling"
            >
                <Icon className="icon-delete black" />
            </button>
        </div>
    );
}
